import { type Transition, type Variants } from 'framer-motion';

export const commonTransition = {
  type: 'spring',
  damping: 20,
  stiffness: 120,
} satisfies Transition;

export const searchVariants = {
  hidden: {
    opacity: 0.9,
    y: '-100%',
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ...commonTransition,
      delayChildren: 0.05,
    },
  },
} satisfies Variants;

export const searchChildVariants = {
  hidden: { y: '-100%' },
  visible: { y: 0 },
} satisfies Variants;
